import LoginSideBar from "../../components/common/LoginSidebar";
import LoginForm from "../../components/login/LoginForm";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { isLoggedIn } from "../../components/authProvider/AuthContext";

const Login = () => {
  const navigate = useNavigate();

  useEffect (() => {
    if(isLoggedIn()) {
      navigate('/dashboard')
    }
  });

  return (
    <div className="flex h-screen p-4 lg:p-8">
      <div className="lg:w-[60%] lg:block hidden">
        <LoginSideBar />
      </div>

      <div className="lg:w-[40%] w-full text-center h-[100%] flex flex-col items-center justify-center">
        <LoginForm />
      </div>
    </div>
  );
}

export default Login;
